import React from 'react'
import { useForm } from 'react-hook-form'
import { useLocation } from '@reach/router'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'
import DfbCheckbox from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_checkbox'
import CStatusParagraph from '@dfb/gatsby-dfb-theme/src/components/elements/c_status_paragraph'
import { closedAreaContent } from '../../../../../../utils/closedArea/content'
import { handleError } from '../../../../../../utils/closedArea/helper_forms'
import { getFanclubApiClient } from '../../../../../../services/fanclubApiClient'
import MSuccessState from './m_success_state'

const MDeleteJourneyForm = ({ data }) => {
  const { userToken, journeyId } = data
  let location = useLocation()
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitSuccessful },
  } = useForm({ mode: 'onSubmit', shouldUnregister: true })

  const deleteJourney = async () => {
    await getFanclubApiClient(userToken()).deleteTrip({
      id: journeyId,
    })
  }

  const onSubmit = handleError(setError, deleteJourney)

  if (isSubmitSuccessful && location.pathname.includes(journeyId)) {
    return (
      <MSuccessState
        data={{
          headline: closedAreaContent.forms.journeys.success.headlines.delete,
          description: closedAreaContent.forms.journeys.success.text.delete,

          backlink: {
            link: closedAreaContent.forms.journeys.backlink.path,
            text: closedAreaContent.forms.journeys.backlink.label,
          },
        }}
      />
    )
  } else if (isSubmitSuccessful) {
    window.location.reload()
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} data-testid="delete-journey-dialog-form">
      <DfbParagraph add_class="m-Formblock-text" text={closedAreaContent.modals.journeys.description} />

      <div className="m-Formblock-checkbox" data-testid="delete-information-confirmation">
        <DfbCheckbox
          text={closedAreaContent.modals.journeys.checkbox}
          {...register('confirmDelete', { required: true })}
          required
          error={!!errors.confirmDelete}
        />
        {errors.confirmDelete && (
          <p className="dfb-Paragraph dfb-Paragraph--small dfb-Input-errorMessage" style={{ display: 'block' }}>
            {closedAreaContent.forms.errors.mandatory}
          </p>
        )}
      </div>
      {errors.root && <CStatusParagraph status="error" paragraph={closedAreaContent.forms.errors.submit} />}
      <DfbButton
        type="submit"
        text={closedAreaContent.modals.journeys.button.label}
        add_class="m-Formblock-button"
        testid="submit-delete-journey"
      ></DfbButton>
    </form>
  )
}

export default MDeleteJourneyForm
